import React, { Component, Fragment } from "react";
import { Carousel, Container, Image } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import cart from "../../assets/images/icon-cart.svg";
import Contact from "../../components/UI/Alerts/Contact/Contact";
import Button from "../../components/UI/Button/Button";
import Modal from "../../components/UI/Modal/Modal";
import { logFirebaseEvent } from "../../shared/utility";
import ProcedureSearch from "./ProcedureSearch/ProcedureSearch";
import classes from "./ProcedureShopper.module.css";

interface IStateFromProps {
  config_values: {
    customValue: string | null;
    defaultValue: string;
    element: string;
    elementType: string;
    id: string;
    targetPageTitle: string;
  }[];
  t: any;
}

type Props = IStateFromProps;
class ProcedureShopper extends Component<Props> {
  state = {
    connect: false,
    getStarted: false,
  };

  componentDidMount() {
    logFirebaseEvent("ProcedureShopper");
  }
  getStartedHandler = () => {
    this.setState({ getStarted: true });
  };
  goBackHandler = () => {
    this.setState({ getStarted: false });
  };
  contactHandler = () => {
    logFirebaseEvent("ContactCareNavigatorButtonPressed");
    this.setState({ connect: true });
  };
  connectedHandler = () => {
    this.setState({ connect: false });
  };
  render() {
    let { t } = this.props;
    const btnStyle = {
      margin: "5px",
    };
    const modalContact = {
      width: "360px",
      left: "calc(50% - 180px)",
    };
    let procedureShopper: any;
    if (this.state.getStarted) {
      procedureShopper = (
        <ProcedureSearch t={this.props.t} goBackHandler={this.goBackHandler} />
      );
    } else {
      procedureShopper = (
        <Fragment>
          <Modal
            show={this.state.connect}
            childComp={
              <Contact
                modalClosed={this.connectedHandler}
                email="carenavigator@advancedpricing.com"
                contactNumber="(888) 641-8834"
                contactText={t("contact.careerNavigator")}
                logEvent="ContactCareNavigatorEmailButtonPressed"
              />
            }
            style={modalContact}
          ></Modal>
          <Container fluid>
            <Carousel
              controls={false}
              interval={null}
              indicators={true}
              className={classes.carousel}
            >
              <Carousel.Item>
                <div className="carouselBanner carouselBannerImg">
                  <h2 className="carouselTitle">
                    {t("procedureShopper.procedureShopperTitle1")}
                  </h2>

                  <Image src={cart} alt="cart" />
                </div>
                <div className={classes.bannerContent}>
                  <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Procedure Shopper Overview".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Procedure Shopper Overview".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "Procedure Shopper Overview".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "Procedure Shopper Overview".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                      : ``}
                  </p>
                  {/* <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Procedure Shopper Overview".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Procedure Shopper Overview".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "Procedure Shopper Overview".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n\n")[0]
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "Procedure Shopper Overview".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue.split("\n\n")[0]
                      :t('procedureShopper.procedureDescription1')}
                  </p>
                  <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Procedure Shopper Overview".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Procedure Shopper Overview".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "Procedure Shopper Overview".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n\n")[1]
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "Procedure Shopper Overview".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue.split("\n\n")[1]
                      :t('procedureShopper.procedureDescription12')}
                  </p>
                  <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Procedure Shopper Overview".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Procedure Shopper Overview".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "Procedure Shopper Overview".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n\n")[2]
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "Procedure Shopper Overview".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue.split("\n\n")[2]
                      :t('procedureShopper.procedureDescription123')}
                  </p>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="carouselBanner">
                  <h2 className="carouselTitle">{t('procedureShopper.procedureShopperTitle2')}</h2>
                </div>
                <div className={classes.bannerContent}>
                  {/* <p>
                    {" "}
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "About Care Navigation - 1".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "About Care Navigation - 1".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 1".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n\n")[0]
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 1".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue.split("\n\n")[0]
                      :t('procedureShopper.procedureDescription2')}
                  </p>
                  <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "About Care Navigation - 1".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "About Care Navigation - 1".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 1".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n\n")[1]
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 1".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue.split("\n\n")[1]
                      : `If you are interested in learning more, get started below or
                      reach out to the Care Navigation team at (888) 641-8834 or
                      carenavigator@advancedpricing.com. Office hours are Monday –
                      Friday, 8 am – 4:30 pm EST.`}
                  </p> */}
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="carouselBanner">
                  <h2 className="carouselTitle">
                    {t("procedureShopper.procedureShopperTitle2")}
                  </h2>
                </div>
                <div className={classes.bannerContent}>
                  <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "About Care Navigation - 1".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "About Care Navigation - 1".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 1".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 1".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                      : ``}
                  </p>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="carouselBanner">
                  <h2 className="carouselTitle">
                    {t("procedureShopper.procedureShopperTitle2")}
                  </h2>
                </div>
                <div className={classes.bannerContent}>
                  <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "About Care Navigation - 2".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "About Care Navigation - 2".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 2".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 2".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                      : ``}
                  </p>
                  {/* <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "About Care Navigation - 2".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "About Care Navigation - 2".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 2".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n\n")[0]
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 2".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue.split("\n\n")[0]
                      :t('procedureShopper.procedureDescription4')}
                  </p>
                  <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "About Care Navigation - 2".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "About Care Navigation - 2".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 2".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n\n")[1]
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 2".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue.split("\n\n")[1]
                      : `Remember, if you are in pain or need assistance immediately,
                      proceed with what your doctor has recommended to you.`}
                  </p> */}
                  {/* <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "About Care Navigation - 2".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "About Care Navigation - 2".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 2".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "About Care Navigation - 2".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                      : ``}
                  </p> */}
                </div>
              </Carousel.Item>
            </Carousel>
            <div className={classes.botButtons}>
              <Button
                label={t("procedureShopper.getStartedBtn")}
                clicked={this.getStartedHandler}
                style={btnStyle}
                displayImg={false}
                image=""
                disabled={false}
              />
              <Button
                label={t("procedureShopper.contact")}
                clicked={this.contactHandler}
                style={btnStyle}
                displayImg={false}
                image=""
                disabled={false}
              />
            </div>
          </Container>
        </Fragment>
      );
    }
    return <Fragment>{procedureShopper}</Fragment>;
  }
}

const mapStateToProps = (state: any) => ({
  config_values: state.appConfig.config_values,
});

export default connect(mapStateToProps)(withTranslation()(ProcedureShopper));
